// Add this component definition within your main component or import it
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../Component/Loader";
const ReferralTreeComponent = () => {
  const navigate = useNavigate();
  const [loading, setloading] = useState(true); // Start with loading true
  const [expandedNodes, setExpandedNodes] = useState(
    new Set([10, 20, 23, 24, 25])
  );
  const [data, setData] = useState(null); // Start with null
  console.log('data1234: ', data);
  let userInfo = JSON.parse(localStorage?.getItem("userDetails"));
  console.log('userInfo1234: ', userInfo);
  
  useEffect(() => {
    callCustomerDetails();
  }, []);

  const callCustomerDetails = async () => {
    let token = localStorage.getItem("token");
    let maxLevels = 9;

    let formData = new FormData();
    formData.append("customerId", userInfo?.id);

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}getcustomerreferraltree?clientId=${process.env.REACT_APP_Client_Id}&maxLevels=${maxLevels}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((responseData) => {
        if (
          responseData &&
          (responseData.detail === "The Token is expired" ||
            responseData.message === "Invalid token" ||
            responseData.message === "Invalid Credentials.")
        ) {
          localStorage.clear();
          navigate("/");
          window.location.reload();
          return;
        }
        if (responseData && responseData.status) {
          setData(responseData.data); // Set the actual data from API
          setloading(false);
        } else if (responseData.message !== "Invalid token") {
          toast.error(responseData?.message);
          setloading(false);
        }
      })
      .catch((error) => {
        console.log("error: ", error);
        setloading(false);
        setTimeout(() => {
          toast.error("AA2 There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  };

  const toggleNode = (nodeId) => {
    const newExpanded = new Set(expandedNodes);
    if (newExpanded.has(nodeId)) {
      newExpanded.delete(nodeId);
    } else {
      newExpanded.add(nodeId);
    }
    setExpandedNodes(newExpanded);
  };

  const getLevelColor = (level) => {
    const colors = [
      "background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%); border: 2px solid #f87171;",
      "background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%); border: 2px solid #60a5fa;",
      "background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%); border: 2px solid #34d399;",
      "background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%); border: 2px solid #facc15;",
      "background: linear-gradient(135deg, #e9d5ff 0%, #d8b4fe 100%); border: 2px solid #a855f7;",
      "background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%); border: 2px solid #ec4899;",
      "background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%); border: 2px solid #6366f1;",
      "background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%); border: 2px solid #6b7280;",
      "background: linear-gradient(135deg, #fed7aa 0%, #fdba74 100%); border: 2px solid #fb923c;",
      "background: linear-gradient(135deg, #ccfbf1 0%, #99f6e4 100%); border: 2px solid #2dd4bf;",
      "background: linear-gradient(135deg, #cffafe 0%, #a5f3fc 100%); border: 2px solid #22d3ee;",
    ];
    return colors[(level - 1) % colors.length];
  };

  if (loading) return <Loader />;

  const ReferralNode = ({ customer, isRoot = false }) => {
    const hasChildren = customer.referrals && customer.referrals.length > 0;
    const isExpanded = expandedNodes.has(customer.id);
    const levelStyle = getLevelColor(customer.level);

    return (
      <div style={{ position: "relative", marginBottom: "16px" }}>
        <div
          style={{
            ...levelStyle.split(";").reduce((acc, style) => {
              const [property, value] = style.split(":").map((s) => s.trim());
              if (property && value) {
                acc[property.replace(/-([a-z])/g, (g) => g[1].toUpperCase())] =
                  value;
              }
              return acc;
            }, {}),
            borderRadius: "12px",
            padding: "20px",
            boxShadow: isRoot
              ? "0 8px 25px rgba(239, 68, 68, 0.3)"
              : "0 4px 12px rgba(0, 0, 0, 0.1)",
            cursor: hasChildren ? "pointer" : "default",
            transition: "all 0.3s ease",
            transform: isExpanded ? "scale(1.02)" : "scale(1)",
          }}
          onClick={() => hasChildren && toggleNode(customer.id)}
        >
          {/* <div style={{ 
            background: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)', 
            padding: '20px', 
            borderRadius: '12px', 
            border: '2px solid #34d399' 
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <i className="fa fa-wallet" style={{ color: '#10b981', fontSize: '24px' }}></i>
              <div>
                <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>Total Balance</p>
                <p style={{ fontSize: '28px', fontWeight: 'bold', color: '#10b981', margin: 0 }}>
                  ₹{calculateTotalBalance()}
                </p>
              </div>
            </div>
          </div> */}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "12px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              {hasChildren && (
                <div style={{ color: "#6b7280", transition: "transform 0.2s" }}>
                  <i
                    className={`fa ${
                      isExpanded ? "fa-chevron-down" : "fa-chevron-right"
                    }`}
                    style={{ fontSize: "16px" }}
                  ></i>
                </div>
              )}
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <i
                  className="fa fa-user"
                  style={{ color: "#6b7280", fontSize: "18px" }}
                ></i>
                <div>
                  <h3
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      margin: 0,
                      color: "#1f2937",
                    }}
                  >
                    {customer.customerName}
                  </h3>
                  <p style={{ fontSize: "14px", color: "#6b7280", margin: 0 }}>
                    Code: {customer.referralCode}
                  </p>
                </div>
              </div>
            </div>

            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: "14px", color: "#6b7280" }}>
                Level {customer.level}
              </div>
              {isRoot && (
                <div
                  style={{
                    fontSize: "12px",
                    color: "#ef4444",
                    fontWeight: "bold",
                  }}
                >
                  ROOT
                </div>
              )}
            </div>
          </div>

          {!isRoot && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: "16px",
                fontSize: "14px",
                marginTop: "16px",
              }}
            >
              {/* <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <i className="fa fa-wallet" style={{ color: '#10b981', fontSize: '16px' }}></i>
                <span>Balance: <strong>₹{customer.walletBalance || 0}</strong></span>
              </div> */}

              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <i
                  className="fa fa-users"
                  style={{ color: "#3b82f6", fontSize: "16px" }}
                ></i>
                <span>
                  Direct Referrals:{" "}
                  <strong>{customer.totalDirectReferrals}</strong>
                </span>
              </div>

              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <i
                  className="fa fa-calendar"
                  style={{ color: "#8b5cf6", fontSize: "16px" }}
                ></i>
                <span>
                  Joined: <strong>{customer.joinedDate}</strong>
                </span>
              </div>
            </div>
          )}

          {!isRoot && customer.referrerName && (
            <div
              style={{ marginTop: "12px", fontSize: "12px", color: "#6b7280" }}
            >
              Referred by: <strong>{customer.referrerName}</strong>
            </div>
          )}
        </div>

        {hasChildren && isExpanded && (
          <div
            style={{
              marginLeft: "32px",
              borderLeft: "3px solid #d1d5db",
              paddingLeft: "16px",
              marginTop: "16px",
            }}
          >
            {customer.referrals.map((referral) => (
              <ReferralNode key={referral.id} customer={referral} />
            ))}
          </div>
        )}
      </div>
    );
  };

  const calculateTotalBalance = () => {
    const calculateNodeBalance = (node) => {
      let total = node.walletBalance || 0;
      if (node.referrals && node.referrals.length > 0) {
        node.referrals.forEach((child) => {
          total += calculateNodeBalance(child);
        });
      }
      return total;
    };

    if (!data?.referralTree || !Array.isArray(data.referralTree)) {
      return 0;
    }

    // Add root customer balance if it exists
    let rootBalance = data.rootCustomer?.walletBalance || 0;
    
    return rootBalance + data.referralTree.reduce(
      (total, node) => total + calculateNodeBalance(node),
      0
    );
  };

  const calculateTotalMembers = () => {
    const countNodes = (node) => {
      let count = 1;
      if (node.referrals && node.referrals.length > 0) {
        node.referrals.forEach((child) => {
          count += countNodes(child);
        });
      }
      return count;
    };

    if (!data?.referralTree || !Array.isArray(data.referralTree)) {
      return 1; // Just the root customer
    }

    return (
      1 + data.referralTree.reduce((total, node) => total + countNodes(node), 0)
    );
  };

  // Show loader while data is being fetched
  if (loading || !data) return <Loader />;

  return (
    <div
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "24px",
        backgroundColor: "#f8f9fa",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          padding: "24px",
          marginBottom: "24px",
        }}
      >
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            color: "#1f2937",
            marginBottom: "16px",
            textAlign: "center",
          }}
        >
          Referral Network Tree
        </h1>

        {/* <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "16px",
            marginBottom: "24px",
          }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)",
              padding: "20px",
              borderRadius: "12px",
              border: "2px solid #60a5fa",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <i
                className="fa fa-users"
                style={{ color: "#3b82f6", fontSize: "24px" }}
              ></i>
              <div>
                <p style={{ fontSize: "14px", color: "#6b7280", margin: 0 }}>
                  Total Members
                </p>
                <p
                  style={{
                    fontSize: "28px",
                    fontWeight: "bold",
                    color: "#3b82f6",
                    margin: 0,
                  }}
                >
                  {calculateTotalMembers()}
                </p>
              </div>
            </div>
          </div>

          <div
            style={{
              background: "linear-gradient(135deg, #e9d5ff 0%, #d8b4fe 100%)",
              padding: "20px",
              borderRadius: "12px",
              border: "2px solid #a855f7",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div
                style={{
                  width: "24px",
                  height: "24px",
                  backgroundColor: "#a855f7",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                10
              </div>
              <div>
                <p style={{ fontSize: "14px", color: "#6b7280", margin: 0 }}>
                  Max Depth
                </p>
                <p
                  style={{
                    fontSize: "28px",
                    fontWeight: "bold",
                    color: "#a855f7",
                    margin: 0,
                  }}
                >
                  10 Levels
                </p>
              </div>
            </div>
          </div>
        </div> */}

        <div
          style={{
            fontSize: "14px",
            color: "#6b7280",
            marginBottom: "16px",
            textAlign: "center",
          }}
        >
          <p style={{ margin: 0 }}>
            <strong>Tip:</strong> Click on members with referrals to
            expand/collapse their network
          </p>
        </div>
      </div>

      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          padding: "24px",
        }}
      >
        <ReferralNode customer={data.rootCustomer} isRoot={true} />

        <div>
          {data.referralTree && data.referralTree.length > 0 && 
            data.referralTree.map((customer) => (
              <ReferralNode key={customer.id} customer={customer} />
            ))
          }
        </div>
      </div>
    </div>
  );
};
export default ReferralTreeComponent;
